export default __webpack_public_path__ + "static/media/Let_s Have Some Fun~ 2.b6134ba5.png";